module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 21
// module chunks = 0 1